module.exports = __webpack_public_path__ + "static/media/severity3.135f531e.png";